import * as Yup from "yup";
import { transformSnakeToCamel } from "utils/transform";

import { ERROR_MESSAGES } from "constants/validation";

/**
 * Category Schema
 * Represents a category that can be promoted by affiliates
 * Base schema is loose to allow loading legacy data.
 */
export const CategorySchema = Yup.object()
  .transform(transformSnakeToCamel)
  .shape({
    id: Yup.string().nullable(),
    name: Yup.string().nullable(),
    createdAt: Yup.date().nullable(),
    updatedAt: Yup.date().nullable(),
  });

/**
 * Category Validation Schema
 * Strict rules applied only during form submission.
 */
export const CategoryValidationSchema = CategorySchema.clone().shape({
  id: Yup.string().required(ERROR_MESSAGES.REQUIRED),
  name: Yup.string().required(ERROR_MESSAGES.CATEGORY_NAME_REQUIRED),
});
